<script setup lang="ts">
import InputNumber from 'primevue/inputnumber'
import InputText from 'primevue/inputtext'
import Dropdown from 'primevue/dropdown'
import type { BatchRoll } from '@/types/batch-types'
import { computed, watch, ref, onMounted } from 'vue'
import { unitOptions } from '@/constants/dimension'

const props = defineProps<{
  modelValue: BatchRoll
  editable: boolean
  showActions: boolean
  fabricYieldValue?: number
  fabricYieldUnit?: number
}>()
const emit = defineEmits<{
  (event: 'update:modelValue', value: BatchRoll): void
  (event: 'remove', value: BatchRoll): void
}>()

const model = defineModel<BatchRoll>('modelValue', { required: true })

const updateRoll = (property: keyof BatchRoll, value: any) => {
  const updatedRoll: BatchRoll = {
    ...props.modelValue,
    [property]: value
  }

  if (property === 'weight' && props.fabricYieldValue && value) {
    updatedRoll.lengthValue = value * props.fabricYieldValue
    updatedRoll.lengthUnit = props.fabricYieldUnit || 0
  }

  emit('update:modelValue', updatedRoll)
}

const rollNumber = computed({
  get: () => props.modelValue.rollNumber,
  set: (value) => updateRoll('rollNumber', value)
})

const lengthValue = computed({
  get: () => props.modelValue.lengthValue,
  set: (value) => updateRoll('lengthValue', value)
})

const lengthUnit = computed({
  get: () => props.modelValue.lengthUnit,
  set: (value) => updateRoll('lengthUnit', value)
})

const weight = computed({
  get: () => props.modelValue.weight,
  set: (value) => updateRoll('weight', value)
})

const remove = () => emit('remove', model.value)

const id = (propertyName: string) => `roll-${model.value.id}-${propertyName}`
</script>

<template>
  <div class="grid grid-cols-12 gap-x-10">
    <div class="col-span-2">
      <label :for="id('rollNumber')" class="text-xs">Roll No.</label>
      <InputText
        v-model="rollNumber"
        :disabled="!editable"
        :id="id('rollNumber')"
        class="w-full text-sm h-8"
        input-class="max-w-full"
      />
    </div>
    <div class="col-span-2">
      <label :for="id('lengthValue')" class="text-xs">New Length</label>
      <InputNumber
        v-model="lengthValue"
        :disabled="!editable"
        :id="id('lengthValue')"
        class="w-full text-sm h-8"
        input-class=" max-w-full"
      />
    </div>
    <div class="col-span-2">
      <label :for="id('lengthUnit')" class="text-xs">New Unit</label>
      <Dropdown
        v-model="lengthUnit"
        :disabled="!editable"
        class="w-full text-sm h-8"
        input-class=" max-w-full"
        :id="id('lengthUnit')"
        :options="unitOptions"
        optionLabel="label"
        optionValue="value"
        type="number"
      />
    </div>
    <div class="col-span-2">
      <label :for="id('weight')" class="text-xs"> New Weight</label>
      <InputNumber
        v-model="weight"
        :disabled="!editable"
        :id="id('weight')"
        class="w-full text-sm h-8"
        input-class="max-w-full"
      />
    </div>

    <!-- <div class="col-span-2 flex items-end justify-between" v-if="showActions">
      <div class="flex flex-wrap items-center gap-4">

        <Button v-if="model.active" @click="remove" size="small" outlined severity="danger">
          Remove
          <Icon icon="ep:remove-filled" class="ml-3" />
        </Button>

        <Tag :severity="model.active ? 'success' : 'danger'" class="!px-3">
          <Icon icon="ri:plane-fill" class="text-lg me-2" />
          {{ model.active ? 'Active' : 'Inactive' }}
        </Tag>
      </div>
    </div> -->
  </div>
</template>

<style scoped></style>
